import type { BigFraction } from "@aprao/common/src/math/BigFraction.js";
import { bigFractionFromFraction } from "@aprao/common/src/math/BigFraction.js";
import { makeAutoObservable } from "mobx";

import type { ShapeSalesTaxConfiguration } from "../shapes/ShapeProject.js";
import { WithNameDelegate } from "./delegates/WithNameDelegate.js";

export class SalesTaxConfigurationFacade {
  constructor(readonly $model: ShapeSalesTaxConfiguration) {
    makeAutoObservable(this);
  }

  get named() {
    return new WithNameDelegate(this.$model);
  }

  get value() {
    return bigFractionFromFraction(this.$model.value);
  }

  get marginSchemeEnabled() {
    return this.$model.isMarginScheme;
  }

  set value(value: BigFraction) {
    this.$model.value = value.toFraction();
  }

  set marginSchemeEnabled(isMarginScheme: boolean) {
    this.$model.isMarginScheme = isMarginScheme;
  }
}
